import * as types from "./types";

import {getExpenseListAxios, postExpenseListAxios, updateExpenseListAxios, deleteExpenseListAxios} from  "./services";

export async function getExpenseListAction({ commit }, id) {
    commit(types.LOADING_ITEM, true);
    try {
        const { data } = await getExpenseListAxios(id);
        commit(types.GET_EXPENSE_LIST, data.result);
        return data.result;
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_ITEM, false);
    }
}

export async function postExpenseAction({ commit }, payload) {
    commit(types.LOADING_ITEM, true);
    try {
        const { data } = await postExpenseListAxios(payload);
        commit(types.POST_EXPENSE, data.result);
        return data;
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_ITEM, false);
    }
}

export async function updateExpenseAction({ commit }, payload) {
    commit(types.LOADING_ITEM, true);
    try {
        const { data } = await updateExpenseListAxios(payload);
        commit(types.UPDATE_EXPENSE, data.result);
        return data;
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_ITEM, false);
    }
}

export async function deleteExpenseAction({ commit }, id) {
    commit(types.LOADING_ITEM, true);
    try {
        const { data } = await deleteExpenseListAxios(id);
        commit(types.DELETE_EXPENSE, data.result);
    }
    catch (e) {
        throw e;
    }
    finally {
        commit(types.LOADING_ITEM, false);
    }
}